<h3>
    <span class="title" ng-bind-html="item.Title|cHighlight:highlight"></span>
</h3>
<div class="property-container">
    <ul class="workflow-property-list">
        <li ng-repeat="prop in item.itemProperties track by $index">{{prop.value}}</li>
    </ul>
</div>
